import type { RootState } from '../store';

export const selectBrandProfileList = (state: RootState) => state.brandProfiles.brandProfilesList;
export const selectBrandProfilesLoading = (state: RootState) => state.brandProfiles.loading;
